import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  fieldsBagName: 'inputs ', // Default is fields
});



// WEBPACK FOOTER //
// ./src/plugins/validation.js